import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  CombinationRulePostSchema,
  CombinationRulePutSchema,
  CombinationRulesPrecheckResponse,
  CombinationRulesResponse,
  ICombinationRule,
  IParamsCombinationRules,
  IRuleFilterDealer,
  IRuleFilterPosition,
  PlacePostTypesResponse,
  RuleFilterCategoriesResponse,
} from "~/entity/CombinationRules/model/schema";
import { paramsSerializer } from "~/shared/lib/paramsSerializer";

const combinationRulesServiceMap = {
  rules: "/rules",
  placePostTypes: "/place-posts/types",
  filterDealers: "/rules/filters/dealers",
  filterCategories: "/rules/filters/categories",
  filterPositions: "/rules/filters/positions",
};

export class CombinationRulesService {
  static GET = {
    getRules: (
      params: IParamsCombinationRules,
    ): NetworkResponse<CombinationRulesResponse> =>
      requestREST.get(combinationRulesServiceMap.rules, {
        params,
        paramsSerializer: (params) => paramsSerializer(params),
      }),
    getRuleById: (id: number | string): NetworkResponse<ICombinationRule> =>
      requestREST.get(`${combinationRulesServiceMap.rules}/${id}`),
    getPlacePostTypes: (): NetworkResponse<PlacePostTypesResponse> =>
      requestREST.get(combinationRulesServiceMap.placePostTypes),
    getRulesReport: (
      responseType: "blob" | "text" = "text",
    ): NetworkResponse<Blob | string> =>
      requestREST.get(`${combinationRulesServiceMap.rules}/report`, {
        params: { format: "excel" },
        responseType,
      }),
    getFilterDealers: (): NetworkResponse<IRuleFilterDealer[]> =>
      requestREST.get(combinationRulesServiceMap.filterDealers),
    getFilterCategories: (): NetworkResponse<RuleFilterCategoriesResponse> =>
      requestREST.get(combinationRulesServiceMap.filterCategories),
    getFilterPositions: (): NetworkResponse<IRuleFilterPosition[]> =>
      requestREST.get(combinationRulesServiceMap.filterPositions),
  };

  static POST = {
    createRule: (
      data: CombinationRulePostSchema,
    ): NetworkResponse<ICombinationRule> =>
      requestREST.post(combinationRulesServiceMap.rules, data),
    precheckAllRules: (): NetworkResponse<CombinationRulesPrecheckResponse> =>
      requestREST.post(`${combinationRulesServiceMap.rules}/precheck-all`),
    checkAllRules: (): NetworkResponse<void> =>
      requestREST.post(`${combinationRulesServiceMap.rules}/check-all`),
  };

  static PUT = {
    putRule: (
      id: number | string,
      data: CombinationRulePutSchema,
    ): NetworkResponse<ICombinationRule> =>
      requestREST.put(`${combinationRulesServiceMap.rules}/${id}`, data),
  };

  static PATCH = {
    toggleRule: (id: number | string): NetworkResponse<ICombinationRule> =>
      requestREST.patch(`${combinationRulesServiceMap.rules}/${id}/toggle`),
  };

  static DELETE = {
    deleteRule: (id: number | string): NetworkResponse<void> =>
      requestREST.delete(`${combinationRulesServiceMap.rules}/${id}`),
  };
}
